import { lazy } from 'react';

const ResetPassword = lazy(
  () => import('./ResetPassword'),
);

export { ResetPassword };
